
import Alert from 'vux/src/components/alert/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
components: {
Cell,
Group,
CellBox,
Confirm,
Alert,
XButton,
Tab,
TabItem,
Swiper,
SwiperItem,
Toast
},
data() {
return {
select: this.$route.query.select ? this.$route.query.select : '',
list: ['用户'],
index: 0,
flag: false,
imgUrl: '/static/img/home.png',
isid: '',
role: ''
}
},
methods: {
ordermanage() {
var openid = localStorage.getItem('openid')
const unionid = localStorage.getItem('unionid')
var that = this
this.$http.get('api/v1/wechat/' + unionid).then(res => {



if (res.data.length > 0) {
let account = res.data[0].account
that.$http.post('api/v1/wechat/' + unionid + '/token', {'account': account})
.then(res => {
localStorage.setItem('token', res.data.token)
localStorage.setItem('userid', res.data.userid)
var obj = {
headers: {
token: res.data.token,
opid: res.data.userid
}
}
that.$http.get('api/v1/accounts/' + res.data.userid, obj).then(function (response) {
for (var i = 0; i < response.data.length; i++) {
if (response.data[i].type == 'INDV' || response.data[i].type == 'ENTP') {
that.isid = response.data[i].type
}
}
if (that.isid == 'INDV' || that.isid == 'ENTP') {
that.$router.push({name: 'normalrepairslist'})
} else {
that.$vux.alert.show({
title: '',
content: '您的身份不符合该功能'
})
}

})
that.$router.push({name: 'normalrepairslist'})
})
.catch(function (error) {
if (error.response) {
if (error.response.data) {
that.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
}
}
})
} else {
localStorage.setItem('list', 'true')
localStorage.setItem('repair', 'normalrepairslist')
that.$router.push({name: 'login'})
}
})
},
assistantorder() {
this.$http.get('api/v1/wechat/' + localStorage.getItem('unionid')).then((res) => {
let len = res.data.length
if (len) {
this.$router.push({name: 'assistantorder'})
} else {
localStorage.setItem('repair', 'assistantorder')
localStorage.setItem('repairtype', 'EXPT')
this.$router.push({name: 'login'})
}
})
},
engineer() {
var openid = localStorage.getItem('openid')
const unionid = localStorage.getItem('unionid')
var that = this
this.$http.get('api/v1/wechat/' + unionid)
.then(function (res) {



if (res.data.length > 0) {
let account = res.data[0].account
localStorage.setItem('account', account)

that.$http.post('api/v1/wechat/' + unionid + '/token', {'account': account})
.then(function (res) {
localStorage.setItem('token', res.data.token)
localStorage.setItem('userid', res.data.userid)
var obj = {
headers: {
token: res.data.token,
opid: res.data.userid
}
}

that.$http.get('api/v1/accounts/' + res.data.userid, obj)
.then(function (response) {
for (var i = 0; i < response.data.length; i++) {
console.log(response.data[i].type)

if (response.data[i].type == 'EXPT' || response.data[i].type == 'SRVP') {
that.isid = response.data[i].type
}
}

if (that.isid == 'EXPT' || that.isid == 'SRVP') {
that.$router.push({name: 'engineer'})
} else {
that.$vux.alert.show({
title: '',
content: '您的身份不符合该功能'
})
}

})
.catch(function (error) {
if (error.response) {
if (error.response.data) {
that.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
}
}
})

})
.catch(function (error) {
if (error.response) {
if (error.response.data) {
that.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
}
}
})

} else {
localStorage.setItem('repair', 'engineer')
that.$router.push({name: 'login'})
}
})
.catch(function (error) {
console.log(error.response)
if (error.response) {
if (error.response.data) {
that.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
}
}
})
},
solution_logs() {
this.$http.get('api/v1/wechat/' + localStorage.getItem('unionid')).then((res) => {
let len = res.data.length
if (len) {
this.$router.push({name: 'solution_logs', params: {role: 'EXPT'}})
} else {
localStorage.setItem('repair', 'solution_logs')
localStorage.setItem('repairtype', 'EXPT')
this.$router.push({name: 'login'})
}
})
},
gohome() {
this.$router.push({name: 'vip'})
},
baoxiu() {
this.$router.push({name: 'normalrepairs'})
},
equipment() {
var openid = localStorage.getItem('openid')
const unionid = localStorage.getItem('unionid')
var that = this
this.$http.get('api/v1/wechat/' + unionid)
.then(res => {



if (res.data.length > 0) {
let account = res.data[0].account
localStorage.setItem('account', account)

that.$http.post('api/v1/wechat/' + unionid + '/token', {'account': account})
.then(function (res) {
localStorage.setItem('token', res.data.token)
localStorage.setItem('userid', res.data.userid)
var obj = {
headers: {
token: res.data.token,
opid: res.data.userid
}
}

that.$http.get('api/v1/accounts/' + res.data.userid, obj)
.then(function (response) {
for (var i = 0; i < response.data.length; i++) {

if (response.data[i].type == 'INDV' || response.data[i].type == 'ENTP') {
that.role = response.data[i].type
break;
}
if (response.data[i].type == 'EXPT' || response.data[i].type == 'SRVP') {
that.isid = response.data[i].type
}
}

if (that.role == 'INDV' || that.role == 'ENTP') {
that.$router.push({name: 'Devicelist'})
} else {
var iden
if (that.isid == 'EXPT') {
iden = '个人用户'
}
if (that.isid == 'SRVP') {
iden = '企业用户'
}

that.$vux.confirm.show({
title: '',
content: '您的身份不符合该功能,如需用该功能,请添加' + iden,
onConfirm() {
that.$router.push({name: 'addmyInfo'})
}
})
}

})
.catch(function (error) {
if (error.response) {
if (error.response.data) {
that.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
}
}
})

})
.catch(function (error) {
if (error.response) {
if (error.response.data) {
that.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
}
}
})
} else {
localStorage.setItem('repair', 'Devicelist')
this.$router.push({name: 'login'})
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/userhomepage.vue